import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
const SelectedEmployeeContext = createContext({
    selectedEmployee: null,
    setSelectedEmployee: () => { },
});
export const SelectedEmployeeProvider = ({ children }) => {
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    return (_jsx(SelectedEmployeeContext.Provider, { value: { selectedEmployee, setSelectedEmployee }, children: children }));
};
export const useSelectedEmployee = () => useContext(SelectedEmployeeContext);
